import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed } from "vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { KamenyUtils } from "@sazka/lotteries/js/utils/kameny-utils";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { StringUtils } from "@sazka/utils/string-utils";
import { TicketCheckResultsBoard } from "@/lotteries/model/ticket-check/ticket-check";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import { usePpWagerPriceCalculator } from "../../composables/use-wager-price-calculator";
import { useWagerBoardStore } from "../../stores/use-wager-board-store";

const EMPTY_CELL_STRING = "–––";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-main-game-table',
  props: {
    lottery: {},
    results: {}
  },
  setup(__props: any) {

const props = __props;
const wagerStore = useWagerBoardStore();
const { kasickaSystemPrice } = usePpWagerPriceCalculator();
const { config } = usePpWagerConfiguration();

const boardLabel = computed(() => LotteryParser.boardLabel(props.lottery));
const showSets = computed(() => props.lottery === Lottery.sportka);
const showExtraWin = computed(() => props.lottery === Lottery.stastnych10);
const showMatchingNumbersCount = computed(() => {
    switch (props.lottery) {
        case Lottery.kameny:
        case Lottery.stastneDatum:
        case Lottery.rychla6:
            return false;
        default:
            return true;
    }
});
const showTotalNumbersCount = computed(() => {
    switch (props.lottery) {
        case Lottery.stastnych10:
        case Lottery.keno:
        case Lottery.kasicka:
            return true;
        default:
            return false;
    }
});
const showWinOrder = computed(() => {
    switch (props.lottery) {
        case Lottery.sportka:
        case Lottery.eurojackpot:
        case Lottery.euromiliony:
        case Lottery.extraRenta:
        case Lottery.miniRenta:
            return true;
        default:
            return false;
    }
});
const showWinnersCount = computed(() => {
    switch (props.lottery) {
        case Lottery.sportka:
        case Lottery.eurojackpot:
        case Lottery.euromiliony:
            return true;
        default:
            return false;
    }
});
const showDeposit = computed(() => {
    switch (props.lottery) {
        case Lottery.stastnych10:
        case Lottery.keno:
        case Lottery.kasicka:
        case Lottery.extraRenta:
        case Lottery.kameny:
            return true;
        default:
            return false;
    }
});

const getBoardLabel = (boardIndex: number, setIndex: number) => {
    if (props.lottery == Lottery.stastnych10 && setIndex == 1) {
        return "Královské číslo";
    }

    if (props.lottery === Lottery.kasicka) {
        const board = wagerStore.boards[boardIndex];
        return wagerStore.isSystem ? "Kombinovaná" : `Sázka na ${LotteryParser.getNumberWithLabel(board.primaryCount)}`;
    }

    return `${boardIndex + 1}. ${boardLabel.value}`;
};

const getStake = (boardIndex: number) => {
    let stake = wagerStore.boards[boardIndex]?.stake;

    if (props.lottery === Lottery.kasicka && wagerStore.isSystem) {
        stake = kasickaSystemPrice();
    }

    if (wagerStore.multiplier) {
        stake = stake * wagerStore.multiplier;
    }

    return stake;
};

const getTotalNumbersCount = (boardIndex: number) => {
    if (wagerStore.isSystem) {
        return wagerStore.systemBoard.primary.length;
    } else {
        return wagerStore.boards[boardIndex]?.primaryCount;
    }
};

const formatNumberWithCurrency = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }

    return EMPTY_CELL_STRING;
};

const formatNumber = (count: number) => {
    return count || EMPTY_CELL_STRING;
};

const formatMatchingNumbers = (board: TicketCheckResultsBoard) => {
    let formattedPrimary = board.matchingPrimary?.join(", ");

    if (config.secondaryBoardSize) {
        let formattedSecondary = board.matchingSecondary?.join(", ");
        formattedPrimary = formattedPrimary || "X";
        formattedSecondary = formattedSecondary || "X";

        return `${formattedPrimary} - ${formattedSecondary}`;
    }

    if (board.matchingExtraNumber) {
        return `${formattedPrimary} + ${board.matchingExtraNumber}`;
    }

    return formattedPrimary || EMPTY_CELL_STRING;
};

const formatMatchingNumbersCount = (board: TicketCheckResultsBoard) => {
    const primaryCount = board.matchingPrimary?.length;

    if (config.secondaryBoardSize) {
        const secondaryCount = board.matchingSecondary?.length;
        const formattedPrimaryCount = primaryCount || "0";
        const formattedSecondaryCount = secondaryCount || "0";

        return `${formattedPrimaryCount} - ${formattedSecondaryCount}`;
    }

    if (board.matchingExtraNumber) {
        return `${primaryCount} + 1`;
    }

    return primaryCount || EMPTY_CELL_STRING;
};

const formatMatchingCombinations = (combinations: number[]) => {
    if (!combinations?.length) {
        return EMPTY_CELL_STRING;
    }

    return KamenyUtils.mapKamenyNumbers(combinations)
        .figures.map((x) => x.text)
        .join(", ");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsTable, {
    "is-scrollable": true,
    "is-responsive": true
  }, {
    default: _withCtx(() => [
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(boardLabel.value), 1)
            ]),
            _: 1
          }),
          (showSets.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 0,
                type: "th"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Tah")
                ])),
                _: 1,
                __: [0]
              }))
            : _createCommentVNode("", true),
          (_ctx.lottery === _unref(Lottery).kameny)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(DsTableCell, { type: "th" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Uhodnuté číslo")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createVNode(DsTableCell, { type: "th" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Uhodnuté kombinace čísel")
                  ])),
                  _: 1,
                  __: [2]
                })
              ], 64))
            : (_openBlock(), _createBlock(DsTableCell, {
                key: 2,
                type: "th"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Uhodnutá čísla")
                ])),
                _: 1,
                __: [3]
              })),
          (showMatchingNumbersCount.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 3,
                type: "th"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Počet")
                ])),
                _: 1,
                __: [4]
              }))
            : _createCommentVNode("", true),
          (showTotalNumbersCount.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 4,
                type: "th"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Počet tipovaných")
                ])),
                _: 1,
                __: [5]
              }))
            : _createCommentVNode("", true),
          (showWinOrder.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 5,
                type: "th"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Pořadí")
                ])),
                _: 1,
                __: [6]
              }))
            : _createCommentVNode("", true),
          (showDeposit.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 6,
                type: "th"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Vklad")
                ])),
                _: 1,
                __: [7]
              }))
            : _createCommentVNode("", true),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Výhra")
            ])),
            _: 1,
            __: [8]
          }),
          (showWinnersCount.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 7,
                type: "th"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Počet výherců")
                ])),
                _: 1,
                __: [9]
              }))
            : _createCommentVNode("", true),
          (showExtraWin.value)
            ? (_openBlock(), _createBlock(DsTableCell, {
                key: 8,
                type: "th"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Extra výhra")
                ])),
                _: 1,
                __: [10]
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (boardResult, index) => {
        return (_openBlock(), _createBlock(DsTableRow, { key: index }, {
          default: _withCtx(() => [
            _createVNode(DsTableCell, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getBoardLabel(boardResult.boardIndex, boardResult.setIndex)), 1)
              ]),
              _: 2
            }, 1024),
            (showSets.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(boardResult.setIndex + 1) + ". tah", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_ctx.lottery === _unref(Lottery).kameny)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(DsTableCell, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatNumber(boardResult.matchingSumNumber)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DsTableCell, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: formatMatchingCombinations(boardResult.matchingCombinations)
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              : (_openBlock(), _createBlock(DsTableCell, { key: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formatMatchingNumbers(boardResult)), 1)
                  ]),
                  _: 2
                }, 1024)),
            (showMatchingNumbersCount.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formatMatchingNumbersCount(boardResult)), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (showTotalNumbersCount.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 4 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTotalNumbersCount(boardResult.boardIndex)), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (showWinOrder.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(boardResult.winOrder), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (showDeposit.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: formatNumberWithCurrency(getStake(boardResult.boardIndex))
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createVNode(DsTableCell, null, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: formatNumberWithCurrency(boardResult.winAmount)
                }, null, 8, _hoisted_3)
              ]),
              _: 2
            }, 1024),
            (showWinnersCount.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 7 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formatNumber(boardResult.winnersCount)), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (showExtraWin.value)
              ? (_openBlock(), _createBlock(DsTableCell, { key: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: formatNumberWithCurrency(boardResult.extraWinAmount)
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})